import React from 'react';
import {ICommentModel} from '@src/@interfaces/models/Comment/ICommentModel';
import TextContainerWithOptionalClassName, {
    TTextContainerWithOptionalClassNameProps
} from '@src/components/CommentsList/PlainComment/TextContainerWithOptionalClassName';
import {IFileModel} from '@src/@interfaces/models/FIle/IFileModel';
import classnames from '@src/helpers/classnames';

function Icon(props: { file: IFileModel, className?: string }) {
    const {file, className} = props;

    return <i className={classnames(className, {
        'far fa-image': file.is_image,
        'far fa-file': !file.is_image,
    })}/>;
}

export default function PlainCommentAttachments(props: {
    comment: ICommentModel,
    maxAttachesToList?: number
} & TTextContainerWithOptionalClassNameProps) {
    const {comment, tag, className, maxAttachesToList = 3} = props;

    if (comment.files == null || !comment.files.length) {
        return null;
    }

    const lastFile = comment.files.at(-1) as IFileModel;
    const lastFileName = (comment.message == null || !comment.message.length) ?
            lastFile?.public_name :
            null;

    if (comment.files.length > maxAttachesToList) {
        return <TextContainerWithOptionalClassName tag={tag} className={className}>
            <i className="far fa-copy me-1"/>
            <Icon file={lastFile} className="me-1"/>
            {lastFileName}
        </TextContainerWithOptionalClassName>;
    }

    return <TextContainerWithOptionalClassName tag={tag} className={className}>
        {comment.files.map((file, i) => {
            const isLast = comment.files.length === (i + 1);

            return <React.Fragment key={file.id}>
                <Icon file={file} className="me-1"/>
                {isLast ? lastFileName : null}
            </React.Fragment>;
        })}
    </TextContainerWithOptionalClassName>;
}
